module.exports = __webpack_public_path__ + "static/img/a001.0265743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a001.jpg
// module id = 7SXT
// module chunks = 0